import { useDropdown } from "../../actions/authActions";
import { useMaincategory, useMainAllcategory } from "../../actions/homeActions";
export default (setSelect) => {
  // Unified handler function 
  const handleDropdwonSelect = (name, value) => {
    setSelect((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const { data: dropdowns, isLoading, isError, error } = useDropdown();
  const {
    data: desiredJobType,
    isLoading: isLoadingMaincategory,
    isError: isErrorMaincategory,
    error: errorMaincategory,
  } = useMainAllcategory("main"); // useMaincategory("main");

  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading dropdowns: {error.message}
        </p>
      </div>
    );
  }
  if (isErrorMaincategory) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading Main Category: {errorMaincategory.message}
        </p>
      </div>
    );
  }
  return {
    desiredJobType,
    isLoadingMaincategory,
    dropdowns,
    isLoading,
    handleDropdwonSelect,
  };
};
